import React from 'react';
import { Logo } from '../components/Logo';
import { ArrowLeftIcon } from 'lucide-react';
export function BrandBook() {
  const blues = [{
    name: 'blue-200',
    hex: '#BFDBFE',
    class: 'bg-blue-200'
  }, {
    name: 'blue-300',
    hex: '#93C5FD',
    class: 'bg-blue-300'
  }, {
    name: 'blue-400',
    hex: '#60A5FA',
    class: 'bg-blue-400'
  }, {
    name: 'blue-500',
    hex: '#3B82F6',
    class: 'bg-blue-500'
  }, {
    name: 'blue-600',
    hex: '#2563EB',
    class: 'bg-blue-600'
  }];
  const grays = [{
    name: 'gray-900',
    hex: '#111827',
    class: 'bg-gray-900'
  }, {
    name: 'gray-700',
    hex: '#374151',
    class: 'bg-gray-700'
  }, {
    name: 'gray-600',
    hex: '#4B5563',
    class: 'bg-gray-600'
  }, {
    name: 'gray-500',
    hex: '#6B7280',
    class: 'bg-gray-500'
  }, {
    name: 'gray-400',
    hex: '#9CA3AF',
    class: 'bg-gray-400'
  }, {
    name: 'gray-200',
    hex: '#E5E7EB',
    class: 'bg-gray-200'
  }, {
    name: 'gray-100',
    hex: '#F3F4F6',
    class: 'bg-gray-100'
  }];
  return <div className="min-h-screen bg-gray-50" data-id="element-356">
      {/* Header */}
      <header className="sticky top-0 z-10 bg-white border-b border-gray-200" data-id="element-357">
        <div className="max-w-5xl mx-auto px-6 py-4 flex items-center justify-between" data-id="element-358">
          <div className="flex items-center gap-3" data-id="element-359">
            <Logo showText={false} size="sm" data-id="element-360" />
            <span className="text-sm font-medium text-gray-900" data-id="element-361">
              Obra Digital — Brand Book
            </span>
          </div>
          <a href="#" onClick={e => {
          e.preventDefault();
          window.location.hash = '';
          window.location.reload();
        }} className="flex items-center gap-1.5 text-sm text-gray-500 hover:text-gray-900 transition-colors" data-id="element-362">
            <ArrowLeftIcon className="w-4 h-4" data-id="element-363" />
            Volver al sitio
          </a>
        </div>
      </header>

      <main className="max-w-5xl mx-auto px-6 py-12 space-y-16" data-id="element-364">
        {/* Logo Section */}
        <section data-id="element-365">
          <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-366">Logo</h2>
          <p className="text-sm text-gray-500 mb-8" data-id="element-367">
            Versiones del logo para diferentes contextos.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-368">
            {/* Logo on white */}
            <div className="bg-white rounded-2xl border border-gray-200 p-10 flex items-center justify-center" data-id="element-369">
              <Logo showText={true} size="lg" variant="dark" data-id="element-370" />
            </div>
            {/* Logo on dark */}
            <div className="bg-[#111827] rounded-2xl p-10 flex items-center justify-center" data-id="element-371">
              <Logo showText={true} size="lg" variant="light" data-id="element-372" />
            </div>
            {/* Isotipo on white */}
            <div className="bg-white rounded-2xl border border-gray-200 p-10 flex items-center justify-center" data-id="element-373">
              <Logo showText={false} size="lg" variant="dark" data-id="element-374" />
            </div>
            {/* Isotipo on dark */}
            <div className="bg-[#111827] rounded-2xl p-10 flex items-center justify-center" data-id="element-375">
              <Logo showText={false} size="lg" variant="light" data-id="element-376" />
            </div>
          </div>

          {/* Size variants */}
          <div className="bg-white rounded-2xl border border-gray-200 p-8" data-id="element-377">
            <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-6" data-id="element-378">
              Tamaños
            </p>
            <div className="flex items-end gap-10" data-id="element-379">
              <div className="text-center" data-id="element-380">
                <Logo showText={true} size="sm" variant="dark" data-id="element-381" />
                <span className="text-xs text-gray-400 mt-3 block" data-id="element-382">sm</span>
              </div>
              <div className="text-center" data-id="element-383">
                <Logo showText={true} size="md" variant="dark" data-id="element-384" />
                <span className="text-xs text-gray-400 mt-3 block" data-id="element-385">md</span>
              </div>
              <div className="text-center" data-id="element-386">
                <Logo showText={true} size="lg" variant="dark" data-id="element-387" />
                <span className="text-xs text-gray-400 mt-3 block" data-id="element-388">lg</span>
              </div>
            </div>
          </div>

          <div className="mt-6 grid grid-cols-2 gap-4 text-sm text-gray-500" data-id="element-389">
            <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-390">
              <span className="font-medium text-gray-700" data-id="element-391">Espacio mínimo</span>
              <p className="text-xs mt-1" data-id="element-392">
                Mantener al menos 1x el ancho del isotipo como margen.
              </p>
            </div>
            <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-393">
              <span className="font-medium text-gray-700" data-id="element-394">No distorsionar</span>
              <p className="text-xs mt-1" data-id="element-395">
                Nunca estirar, rotar o cambiar los colores del logo.
              </p>
            </div>
          </div>
        </section>

        <hr className="border-gray-200" data-id="element-396" />

        {/* Color Palette */}
        <section data-id="element-397">
          <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-398">Colores</h2>
          <p className="text-sm text-gray-500 mb-8" data-id="element-399">
            Paleta de colores de la marca.
          </p>

          {/* Primary */}
          <div className="mb-8" data-id="element-400">
            <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-4" data-id="element-401">
              Primario
            </p>
            <div className="flex items-start gap-4" data-id="element-402">
              <div className="w-24 h-24 rounded-xl bg-blue-600 shadow-sm" data-id="element-403" />
              <div data-id="element-404">
                <p className="font-semibold text-gray-900" data-id="element-405">Blue 600</p>
                <p className="text-sm text-gray-500 font-mono" data-id="element-406">#2563EB</p>
                <p className="text-xs text-gray-400 mt-1" data-id="element-407">bg-blue-600</p>
              </div>
            </div>
          </div>

          {/* Blue scale */}
          <div className="mb-8" data-id="element-408">
            <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-4" data-id="element-409">
              Escala de azules
            </p>
            <div className="flex gap-3" data-id="element-410">
              {blues.map(color => <div key={color.name} className="text-center" data-id="element-411">
                  <div className={`w-14 h-14 rounded-lg ${color.class} shadow-sm`} data-id="element-412" />
                  <p className="text-[10px] text-gray-500 mt-2 font-mono" data-id="element-413">
                    {color.hex}
                  </p>
                  <p className="text-[10px] text-gray-400" data-id="element-414">{color.name}</p>
                </div>)}
            </div>
          </div>

          {/* Gray scale */}
          <div className="mb-8" data-id="element-415">
            <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-4" data-id="element-416">
              Escala de grises
            </p>
            <div className="flex gap-3" data-id="element-417">
              {grays.map(color => <div key={color.name} className="text-center" data-id="element-418">
                  <div className={`w-14 h-14 rounded-lg ${color.class} shadow-sm border border-gray-200`} data-id="element-419" />
                  <p className="text-[10px] text-gray-500 mt-2 font-mono" data-id="element-420">
                    {color.hex}
                  </p>
                  <p className="text-[10px] text-gray-400" data-id="element-421">{color.name}</p>
                </div>)}
            </div>
          </div>

          {/* Dark background */}
          <div data-id="element-422">
            <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-4" data-id="element-423">
              Fondo oscuro
            </p>
            <div className="flex items-start gap-4" data-id="element-424">
              <div className="w-24 h-24 rounded-xl bg-[#111827] shadow-sm" data-id="element-425" />
              <div data-id="element-426">
                <p className="font-semibold text-gray-900" data-id="element-427">Dark</p>
                <p className="text-sm text-gray-500 font-mono" data-id="element-428">#111827</p>
                <p className="text-xs text-gray-400 mt-1" data-id="element-429">bg-[#111827]</p>
              </div>
            </div>
          </div>
        </section>

        <hr className="border-gray-200" data-id="element-430" />

        {/* Typography */}
        <section data-id="element-431">
          <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-432">Tipografía</h2>
          <p className="text-sm text-gray-500 mb-8" data-id="element-433">
            Inter — La fuente principal de la marca.
          </p>

          <div className="bg-white rounded-2xl border border-gray-200 p-8 space-y-6" data-id="element-434">
            <div data-id="element-435">
              <span className="text-xs text-gray-400 block mb-2" data-id="element-436">
                H1 — text-4xl font-extrabold
              </span>
              <h1 className="text-4xl font-extrabold text-gray-900" data-id="element-437">
                Nunca más pierdas registro
              </h1>
            </div>
            <div data-id="element-438">
              <span className="text-xs text-gray-400 block mb-2" data-id="element-439">
                H2 — text-3xl font-bold
              </span>
              <h2 className="text-3xl font-bold text-gray-900" data-id="element-440">
                Precio simple y transparente
              </h2>
            </div>
            <div data-id="element-441">
              <span className="text-xs text-gray-400 block mb-2" data-id="element-442">
                H3 — text-2xl font-bold
              </span>
              <h3 className="text-2xl font-bold text-gray-900" data-id="element-443">
                El caos de la información
              </h3>
            </div>
            <div data-id="element-444">
              <span className="text-xs text-gray-400 block mb-2" data-id="element-445">
                H4 — text-xl font-semibold
              </span>
              <h4 className="text-xl font-semibold text-gray-900" data-id="element-446">
                Así de simple
              </h4>
            </div>
            <hr className="border-gray-100" data-id="element-447" />
            <div data-id="element-448">
              <span className="text-xs text-gray-400 block mb-2" data-id="element-449">
                Body — text-base text-gray-600
              </span>
              <p className="text-base text-gray-600" data-id="element-450">
                Centraliza todas las fotos de obra automáticamente desde
                WhatsApp. Sin apps nuevas, sin fricción.
              </p>
            </div>
            <div data-id="element-451">
              <span className="text-xs text-gray-400 block mb-2" data-id="element-452">
                Small — text-sm text-gray-500
              </span>
              <p className="text-sm text-gray-500" data-id="element-453">
                Menos del 0,1% del presupuesto total de una obra promedio.
              </p>
            </div>
            <div data-id="element-454">
              <span className="text-xs text-gray-400 block mb-2" data-id="element-455">
                Caption — text-xs text-gray-400
              </span>
              <p className="text-xs text-gray-400" data-id="element-456">
                © 2026 Obra Digital. Todos los derechos reservados.
              </p>
            </div>
          </div>

          {/* Font weights */}
          <div className="mt-6 bg-white rounded-2xl border border-gray-200 p-8" data-id="element-457">
            <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-6" data-id="element-458">
              Pesos de fuente
            </p>
            <div className="space-y-4" data-id="element-459">
              <div className="flex items-baseline gap-4" data-id="element-460">
                <span className="w-24 text-xs text-gray-400" data-id="element-461">400 Regular</span>
                <span className="font-normal text-gray-900" data-id="element-462">Obra Digital</span>
              </div>
              <div className="flex items-baseline gap-4" data-id="element-463">
                <span className="w-24 text-xs text-gray-400" data-id="element-464">500 Medium</span>
                <span className="font-medium text-gray-900" data-id="element-465">Obra Digital</span>
              </div>
              <div className="flex items-baseline gap-4" data-id="element-466">
                <span className="w-24 text-xs text-gray-400" data-id="element-467">600 Semibold</span>
                <span className="font-semibold text-gray-900" data-id="element-468">
                  Obra Digital
                </span>
              </div>
              <div className="flex items-baseline gap-4" data-id="element-469">
                <span className="w-24 text-xs text-gray-400" data-id="element-470">700 Bold</span>
                <span className="font-bold text-gray-900" data-id="element-471">Obra Digital</span>
              </div>
              <div className="flex items-baseline gap-4" data-id="element-472">
                <span className="w-24 text-xs text-gray-400" data-id="element-473">
                  800 Extrabold
                </span>
                <span className="font-extrabold text-gray-900" data-id="element-474">
                  Obra Digital
                </span>
              </div>
            </div>
          </div>
        </section>

        <hr className="border-gray-200" data-id="element-475" />

        {/* Buttons */}
        <section data-id="element-476">
          <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-477">Botones</h2>
          <p className="text-sm text-gray-500 mb-8" data-id="element-478">
            Estilos de botones utilizados en la marca.
          </p>

          <div className="bg-white rounded-2xl border border-gray-200 p-8 space-y-8" data-id="element-479">
            {/* Primary */}
            <div data-id="element-480">
              <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-4" data-id="element-481">
                Primario
              </p>
              <div className="flex items-center gap-4" data-id="element-482">
                <button className="px-4 py-2 text-sm font-semibold text-white bg-blue-600 hover:bg-blue-700 rounded-xl transition-colors" data-id="element-483">
                  Pequeño
                </button>
                <button className="px-5 py-2.5 text-base font-semibold text-white bg-blue-600 hover:bg-blue-700 rounded-xl transition-colors" data-id="element-484">
                  Mediano
                </button>
                <button className="px-6 py-3 text-lg font-semibold text-white bg-blue-600 hover:bg-blue-700 rounded-xl transition-colors" data-id="element-485">
                  Grande
                </button>
              </div>
              <p className="text-xs text-gray-400 mt-3 font-mono" data-id="element-486">
                bg-blue-600 text-white rounded-xl
              </p>
            </div>

            {/* Secondary */}
            <div data-id="element-487">
              <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-4" data-id="element-488">
                Secundario
              </p>
              <div className="flex items-center gap-4" data-id="element-489">
                <button className="px-4 py-2 text-sm font-semibold text-gray-700 bg-white border border-gray-300 hover:bg-gray-50 rounded-xl transition-colors" data-id="element-490">
                  Pequeño
                </button>
                <button className="px-5 py-2.5 text-base font-semibold text-gray-700 bg-white border border-gray-300 hover:bg-gray-50 rounded-xl transition-colors" data-id="element-491">
                  Mediano
                </button>
                <button className="px-6 py-3 text-lg font-semibold text-gray-700 bg-white border border-gray-300 hover:bg-gray-50 rounded-xl transition-colors" data-id="element-492">
                  Grande
                </button>
              </div>
              <p className="text-xs text-gray-400 mt-3 font-mono" data-id="element-493">
                border border-gray-300 text-gray-700 bg-white rounded-xl
              </p>
            </div>

            {/* Ghost */}
            <div data-id="element-494">
              <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-4" data-id="element-495">
                Ghost / Texto
              </p>
              <div className="flex items-center gap-4" data-id="element-496">
                <button className="text-sm font-semibold text-blue-600 hover:text-blue-700 transition-colors" data-id="element-497">
                  Enlace de texto
                </button>
              </div>
              <p className="text-xs text-gray-400 mt-3 font-mono" data-id="element-498">
                text-blue-600 hover:text-blue-700
              </p>
            </div>
          </div>
        </section>

        <hr className="border-gray-200" data-id="element-499" />

        {/* Text Colors */}
        <section data-id="element-500">
          <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-501">
            Grises de texto
          </h2>
          <p className="text-sm text-gray-500 mb-8" data-id="element-502">
            Colores de texto para diferentes jerarquías.
          </p>

          <div className="bg-white rounded-2xl border border-gray-200 p-8 space-y-6" data-id="element-503">
            <div data-id="element-504">
              <span className="text-xs text-gray-400 block mb-1" data-id="element-505">
                text-gray-900
              </span>
              <p className="text-gray-900" data-id="element-506">
                Texto principal, títulos y encabezados importantes.
              </p>
            </div>
            <div data-id="element-507">
              <span className="text-xs text-gray-400 block mb-1" data-id="element-508">
                text-gray-700
              </span>
              <p className="text-gray-700" data-id="element-509">
                Texto secundario con buena legibilidad.
              </p>
            </div>
            <div data-id="element-510">
              <span className="text-xs text-gray-400 block mb-1" data-id="element-511">
                text-gray-600
              </span>
              <p className="text-gray-600" data-id="element-512">
                Texto de cuerpo estándar para párrafos.
              </p>
            </div>
            <div data-id="element-513">
              <span className="text-xs text-gray-400 block mb-1" data-id="element-514">
                text-gray-500
              </span>
              <p className="text-gray-500" data-id="element-515">
                Texto de apoyo y descripciones secundarias.
              </p>
            </div>
            <div data-id="element-516">
              <span className="text-xs text-gray-400 block mb-1" data-id="element-517">
                text-gray-400
              </span>
              <p className="text-gray-400" data-id="element-518">
                Texto sutil, captions y metadatos.
              </p>
            </div>
          </div>
        </section>

        <hr className="border-gray-200" data-id="element-519" />

        {/* Spacing & Radius */}
        <section data-id="element-520">
          <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-521">
            Espaciado y Bordes
          </h2>
          <p className="text-sm text-gray-500 mb-8" data-id="element-522">
            Valores de espaciado y radio de borde comunes.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-523">
            {/* Border radius */}
            <div className="bg-white rounded-2xl border border-gray-200 p-8" data-id="element-524">
              <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-6" data-id="element-525">
                Border Radius
              </p>
              <div className="flex items-end gap-4" data-id="element-526">
                <div className="text-center" data-id="element-527">
                  <div className="w-12 h-12 bg-blue-100 rounded-md" data-id="element-528" />
                  <span className="text-[10px] text-gray-400 mt-2 block" data-id="element-529">
                    rounded-md
                  </span>
                </div>
                <div className="text-center" data-id="element-530">
                  <div className="w-12 h-12 bg-blue-100 rounded-lg" data-id="element-531" />
                  <span className="text-[10px] text-gray-400 mt-2 block" data-id="element-532">
                    rounded-lg
                  </span>
                </div>
                <div className="text-center" data-id="element-533">
                  <div className="w-12 h-12 bg-blue-100 rounded-xl" data-id="element-534" />
                  <span className="text-[10px] text-gray-400 mt-2 block" data-id="element-535">
                    rounded-xl
                  </span>
                </div>
                <div className="text-center" data-id="element-536">
                  <div className="w-12 h-12 bg-blue-100 rounded-2xl" data-id="element-537" />
                  <span className="text-[10px] text-gray-400 mt-2 block" data-id="element-538">
                    rounded-2xl
                  </span>
                </div>
                <div className="text-center" data-id="element-539">
                  <div className="w-12 h-12 bg-blue-100 rounded-full" data-id="element-540" />
                  <span className="text-[10px] text-gray-400 mt-2 block" data-id="element-541">
                    rounded-full
                  </span>
                </div>
              </div>
            </div>

            {/* Spacing */}
            <div className="bg-white rounded-2xl border border-gray-200 p-8" data-id="element-542">
              <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-6" data-id="element-543">
                Padding
              </p>
              <div className="space-y-3" data-id="element-544">
                <div className="flex items-center gap-3" data-id="element-545">
                  <div className="bg-blue-600 p-2 rounded" data-id="element-546">
                    <div className="w-4 h-4 bg-white rounded-sm" data-id="element-547" />
                  </div>
                  <span className="text-xs text-gray-500" data-id="element-548">p-2 (8px)</span>
                </div>
                <div className="flex items-center gap-3" data-id="element-549">
                  <div className="bg-blue-600 p-4 rounded" data-id="element-550">
                    <div className="w-4 h-4 bg-white rounded-sm" data-id="element-551" />
                  </div>
                  <span className="text-xs text-gray-500" data-id="element-552">p-4 (16px)</span>
                </div>
                <div className="flex items-center gap-3" data-id="element-553">
                  <div className="bg-blue-600 p-6 rounded" data-id="element-554">
                    <div className="w-4 h-4 bg-white rounded-sm" data-id="element-555" />
                  </div>
                  <span className="text-xs text-gray-500" data-id="element-556">p-6 (24px)</span>
                </div>
                <div className="flex items-center gap-3" data-id="element-557">
                  <div className="bg-blue-600 p-8 rounded" data-id="element-558">
                    <div className="w-4 h-4 bg-white rounded-sm" data-id="element-559" />
                  </div>
                  <span className="text-xs text-gray-500" data-id="element-560">p-8 (32px)</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Footer */}
        <div className="text-center pt-8 pb-4" data-id="element-561">
          <p className="text-xs text-gray-400" data-id="element-562">
            Obra Digital Brand Book — Uso interno
          </p>
        </div>
      </main>
    </div>;
}